theme.mixedContentGrid = (function () {
  function MixedContentGrid(container) {
    this.container = container;
    this.slider = container.querySelector('[data-mixed-grid-slider]');
    this.blockCount = parseInt(container.dataset.blockCount, 10) || 0;
    this.desktopColumns = parseInt(container.dataset.desktopColumns, 10) || 3;
    this.forceSlider = container.dataset.forceSlider === 'true';
    this.swiper = null;
    this.desktopQuery = window.matchMedia('(min-width: 750px)');
    this._onChange = this.mount.bind(this);

    this.mount();

    if (this.desktopQuery.addEventListener) {
      this.desktopQuery.addEventListener('change', this._onChange);
    } else if (this.desktopQuery.addListener) {
      this.desktopQuery.addListener(this._onChange);
    }
  }

  MixedContentGrid.prototype.shouldSlide = function () {
    if (this.forceSlider) return this.blockCount > 1;
    if (this.desktopQuery.matches) return this.blockCount > 4;
    return this.blockCount > 2;
  };

  MixedContentGrid.prototype.mount = function () {
    var enableSlider = this.shouldSlide();

    if (enableSlider && !this.swiper && this.slider && typeof Swiper !== 'undefined') {
      this.swiper = new Swiper(this.slider, {
        slidesPerView: 2.2,
        spaceBetween: 12,
        watchOverflow: true,
        navigation: {
          nextEl: this.container.querySelector('[data-mixed-grid-next]'),
          prevEl: this.container.querySelector('[data-mixed-grid-prev]'),
        },
        breakpoints: {
          750: {
            slidesPerView: this.desktopColumns,
            spaceBetween: 16,
          },
        },
      });
      this.container.classList.add('is-slider');
    } else if (!enableSlider && this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
      this.container.classList.remove('is-slider');
    }
  };

  MixedContentGrid.prototype.onUnload = function () {
    if (this.desktopQuery.removeEventListener) {
      this.desktopQuery.removeEventListener('change', this._onChange);
    } else if (this.desktopQuery.removeListener) {
      this.desktopQuery.removeListener(this._onChange);
    }
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  };

  return MixedContentGrid;
})();
